import { useState, useEffect } from 'react';
import EverTrue from 'app';
import ErrorLogger from 'entities/helpers/error-log-helper';
import Api from 'entities/helpers/api';
import { PageHeader } from '@evertrue/et-components';
import Pagination from 'components/controls/pagination';
import Loading from 'components/elements/loading';
import OutreachTabGroup from '../outreach-tab-group';
import CallsTable from './components/calls-table';

const CALLS_LIMIT = 25;

const PhoneController = () => {
  const handleMainTabChange = (tab) => {
    EverTrue.UrlManager.navigate(`/outreach/${tab}`, true, false);
  };

  const [calls, setCalls] = useState([]);
  const [offset, setOffset] = useState(0);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCalls = async () => {
      setLoading(true);
      try {
        const response = await Api.OUTREACH.CALLS.get({
          params: {
            limit: CALLS_LIMIT,
            offset,
          },
        });
        const callsWithContacts = await resolveContactsForCalls(response.items);
        setCalls(callsWithContacts);
        setTotal(response.total);
      } catch (error) {
        ErrorLogger.error('Error fetching calls:', { error });
      } finally {
        setLoading(false);
      }
    };
    fetchCalls();
  }, [page, offset]);

  const handlePageChange = (page) => {
    setPage(page);
    setOffset((page - 1) * CALLS_LIMIT);
  };

  const paginationTotal = Math.ceil(total / CALLS_LIMIT);

  return (
    <>
      <PageHeader title="Outreach" />
      <OutreachTabGroup activeTab="phone" onTabChange={handleMainTabChange} />
      <div>
        {loading ? (
          <Loading />
        ) : (
          <div className="phone-controller-container">
            <div className="phone-controller-header">
              <div className="phone-controller-header-left">{`${total} Total Calls`}</div>
              <div className="phone-controller-header-center">
                <Pagination total={paginationTotal} page={page} onChange={handlePageChange} />
              </div>
              {calls.length > 0 && (
                <div className="phone-controller-header-right">
                  {`Showing ${offset + 1} - ${offset === 0 ? CALLS_LIMIT : offset + CALLS_LIMIT} of ${total} calls`}
                </div>
              )}
            </div>
            <CallsTable calls={calls} setCalls={setCalls} loading={loading} />
          </div>
        )}
      </div>
    </>
  );
};

export default PhoneController;

// TEMPORARY: This is a temporary query to get the contacts for the calls until we can resolve in Outreach.
const gql = String.raw;
const query = gql`
  query ($ids: [BigInt!]!) {
    contacts(ids: $ids) {
      id
      phones {
        phone
        primary
        type
      }
      profile_image {
        url
        type
      }
      contact_attributes {
        name_full
      }
    }
  }
`;

const resolveContactsForCalls = async (calls) => {
  const callsCopy = [...calls];
  const contactIds = [...new Set(calls.map((call) => call.contact_id).filter(Boolean))];
  const contacts = await Api.GRAPHQL.GRAPHQL.post({
    data: JSON.stringify({
      query: String.raw`${query}`,
      variables: { ids: contactIds },
    }),
  });
  callsCopy.forEach((call) => {
    const contact = contacts.data.contacts.find((c) => c.id === call.contact_id);
    call.contact = contact;
  });
  return callsCopy;
};
